export default __webpack_public_path__ + "atomic/_patterns/03-organisms/form-emergency-donation/_form-emergency-donation.twig";